import { render, staticRenderFns } from "./BaseLoginSMS.vue?vue&type=template&id=85c6d616&scoped=true&"
import script from "./BaseLoginSMS.vue?vue&type=script&lang=js&"
export * from "./BaseLoginSMS.vue?vue&type=script&lang=js&"
import style0 from "./BaseLoginSMS.vue?vue&type=style&index=0&id=85c6d616&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c6d616",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VLayout,VTextField})
